import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import iconLibrary from 'src/app/common/iconLibrary';

@Component({
  selector: 'wct-no-search-results',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './no-search-results.component.html',
  styleUrl: './no-search-results.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NoSearchResultsComponent implements OnDestroy {
  @Input({ required: false }) public icon: string | undefined;
  @Input({ required: false }) public headline: string | undefined;
  @Input({ required: false }) public message: string | undefined;
  @Input({ required: false }) public displayResetButton: boolean = true;

  @Output() public readonly resetClick: Subject<void> = new EventEmitter<void>();

  protected readonly iconLibrary = iconLibrary;

  ngOnDestroy(): void {
    this.resetClick.complete();
  }
}
